<template>
  <el-dialog
    :title="this.type != 'new' ? $t('app.edit') : $t('app.new')"
    :visible.sync="dialogVisible"
    width="400px"
  >
    <el-input
      v-model="code"
      size="small"
      :disabled="this.type != 'new'"
      style="margin-bottom: 20px"
      :placeholder="$t('app.roleCoding')"
    >
    </el-input>
    <el-input v-model="name" size="small" :placeholder="$t('app.roleName')">
    </el-input>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="info" @click="dialogVisible = false">{{
        $t("app.cancel")
      }}</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="loading"
        @click="handleClose"
        >{{ $t("app.confirm") }}</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import { addRole, updateRole } from "@/api/systemManagement/roleManagement";
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      code: "",
      name: "",
      index: "",
      type: "",
      enable: Boolean,
    };
  },
  methods: {
    edit(index, row) {
      this.dialogVisible = true;
      this.code = row.code;
      this.name = row.name;
      this.index = index;
      this.enable = row.enable;
      this.type = "edit";
    },
    new() {
      this.dialogVisible = true;
      this.type = "new";
      this.code = "";
      this.name = "";
      this.index = "";
    },
    handleClose() {
      this.$confirm(
        (this.type === "edit"
          ? this.$t("app.confirmModification")
          : this.$t("app.confirmAdd")) + "?"
      ).then(() => {
        this.loading = true;
        if (this.type === "edit") {
          updateRole({
            RoleCode: this.code,
            RoleName: this.name,
          })
            .then(() => {
              this.success();
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          addRole({
            RoleCode: this.code,
            RoleName: this.name,
          })
            .then(() => {
              this.success();
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    success() {
      this.$message({
        message: this.$t("app.opeSuccess"),
        type: "success",
      });
      if (this.type === "edit") {
        this.$emit("handleSuccess", this.index, {
          code: this.code,
          name: this.name,
          enable: this.enable,
        });
      } else {
        this.$emit("handleAdd", {
          code: this.code,
          name: this.name,
          enable: this.false,
        });
      }
      this.loading = false;
      this.dialogVisible = false;
    },
  },
};
</script>
